//     // import React, { useState } from "react";
//     // import { Button, Form } from "react-bootstrap";
//     // import { downloadNewsPDF } from "../../../services/adminService";

//     // const NewsPDFDownloader = () => {
//     // const [startDate, setStartDate] = useState("");
//     // const [endDate, setEndDate] = useState("");

//     // const handleDownload = async () => {
//     //     if (!startDate || !endDate) {
//     //     alert("Please select both start and end dates.");
//     //     return;
//     //     }
//     //     await downloadNewsPDF(startDate, endDate);
//     // };

//     // return (
//     //     <div className="mt-4 text-center">
//     //     <h4>📅 Download News Report</h4>
//     //     <Form className="d-flex justify-content-center align-items-center gap-2 mt-3">
//     //                  <Form.Label className="fw-bold mb-1">Start Date</Form.Label>

//     //         <Form.Control
//     //         type="date"
//     //         value={startDate}
//     //         onChange={(e) => setStartDate(e.target.value)}
//     //         style={{ width: "200px" }}
//     //         />
//     //         <Form.Control
//     //         type="date"
//     //         value={endDate}
//     //         onChange={(e) => setEndDate(e.target.value)}
//     //         style={{ width: "200px" }}
//     //         />
//     //         <Button variant="success" onClick={handleDownload}>
//     //         ⬇️ Download PDF
//     //         </Button>
//     //     </Form>
//     //     </div>
//     // );
//     // };

//     // export default NewsPDFDownloader;

//     import React, { useState } from "react";
// import { Button, Form } from "react-bootstrap";
// import { downloadNewsPDF } from "../../../services/adminService";

// const NewsPDFDownloader = () => {
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   const handleDownload = async () => {
//     if (!startDate || !endDate) {
//       alert("Please select both start and end dates.");
//       return;
//     }
//     await downloadNewsPDF(startDate, endDate);
//   };

//   return (
//     <div className="mt-4 text-center">
//       <h4>📅 Download News Report</h4>

//       <Form className="d-flex justify-content-center align-items-center gap-3 mt-3 flex-wrap">
//         {/* Start Date */}
//         <div className="d-flex flex-column align-items-start">
//           <Form.Label className="fw-bold mb-1">Start Date</Form.Label>
//           <Form.Control
//             type="date"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//             style={{ width: "200px" }}
//           />
//         </div>

//         {/* End Date */}
//         <div className="d-flex flex-column align-items-start">
//           <Form.Label className="fw-bold mb-1">End Date</Form.Label>
//           <Form.Control
//             type="date"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//             style={{ width: "200px" }}
//           />
//         </div>

//         {/* Download Button */}
//         <div className="d-flex align-items-end">
//           <Button variant="success" onClick={handleDownload}>
//             ⬇️ Download PDF
//           </Button>
//         </div>
//       </Form>
//     </div>
//   );
// };

// export default NewsPDFDownloader;

import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { downloadNewsPDF } from "../../../services/adminService";

const NewsPDFDownloader = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [language, setLanguage] = useState("english"); // ✅ New

  const handleDownload = async () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      return;
    }
    await downloadNewsPDF(startDate, endDate, language);
  };

  return (
    <div className="mt-4 text-center">
      <h4>📅 Download News Report</h4>

      <Form className="d-flex justify-content-center align-items-center gap-3 mt-3 flex-wrap">
        {/* Start Date */}
        <div className="d-flex flex-column align-items-start">
          <Form.Label className="fw-bold mb-1">Start Date</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{ width: "200px" }}
          />
        </div>

        {/* End Date */}
        <div className="d-flex flex-column align-items-start">
          <Form.Label className="fw-bold mb-1">End Date</Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{ width: "200px" }}
          />
        </div>

        {/* Language Select */}
        <div className="d-flex flex-column align-items-start">
          <Form.Label className="fw-bold mb-1">Language</Form.Label>
          <Form.Select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            style={{ width: "200px" }}
          >
            <option value="english">English</option>
            <option value="hindi">Hindi</option>
          </Form.Select>
        </div>

        {/* Download Button */}
        <div className="d-flex align-items-end">
          <Button variant="success" onClick={handleDownload}>
            ⬇️ Download PDF
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default NewsPDFDownloader;

